export default __webpack_public_path__ + "/dist/images/check_img.svg";